import { createContext, useCallback, useContext, useMemo, useState } from "react";

interface ToastContextValue {
  notify: (message: string) => void;
}

const ToastContext = createContext<ToastContextValue>({ notify: () => undefined });

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const [message, setMessage] = useState("");
  const [visible, setVisible] = useState(false);

  const notify = useCallback((text: string) => {
    setMessage(text);
    setVisible(true);
    window.setTimeout(() => setVisible(false), 2400);
  }, []);

  const value = useMemo(() => ({ notify }), [notify]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      <div
        className={`fixed left-1/2 -translate-x-1/2 bottom-8 z-[80] transition-all duration-300 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
        }`}
      >
        <div className="flex items-center gap-2 px-4 py-2.5 rounded-full bg-foreground-950 text-background-50 text-sm max-w-[90vw]">
          <i className="ri-checkbox-circle-line text-accent-400 w-4 h-4 flex items-center justify-center"></i>
          <span className="whitespace-nowrap">{message}</span>
        </div>
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}